import { FC } from 'react';

interface ConnectorTableProps {
  title: string;
  items: { label: string; description: string }[];
  tableHeadings: [string, string];
}

const ConnectorTable: FC<ConnectorTableProps> = ({ title, items, tableHeadings }) => (
  <div className="flex w-full flex-col gap-6 rounded-xl border border-primary-200/30 bg-iconCardGradient px-3 py-6 sm:px-6">
    <h2 className="font-spaceGrotesk text-display-sm font-semibold text-white ">{title}</h2>
    <div className="rounded-lg border	border-primary-200/30">
      <table className="w-full border-collapse">
        <thead>
          <tr>
            {tableHeadings.map(heading => (
              <th
                key={heading}
                className="w-1/2 border-b-2 border-b-white/20 bg-white/10 py-5 text-left text-xl font-bold text-white first:pl-6 last:pr-6 lg:first:w-1/3"
              >
                {heading}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="bg-white/[.05] text-xl text-white [&_td]:border-b-2 [&_td]:border-white [&_td]:border-b-white/20 [&_td]:py-5">
          {items.map(item => (
            <tr key={item.label}>
              <td className="pl-6">{item.label}</td>
              <td className="pr-6">{item.description}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
);

export default ConnectorTable;
